import React from "react";
import { Box } from "@mui/material";
import { LocalizedText } from "../i18n/LocalizedText.js";
const MessageWithIcon = ({ icon, label, iconSize = 16, className }) => {
  return /* @__PURE__ */ React.createElement(Box, { className, display: "flex" }, /* @__PURE__ */ React.createElement(Box, { marginRight: 1, component: "span", className: icon, fontSize: iconSize }), /* @__PURE__ */ React.createElement(LocalizedText, { label }));
};
export {
  MessageWithIcon
};
//# sourceMappingURL=MessageWithIcon.js.map
